import { render, staticRenderFns } from "./TwoFa.vue?vue&type=template&id=3f12782f&"
import script from "./TwoFa.vue?vue&type=script&lang=js&"
export * from "./TwoFa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports